<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />
    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Détails relatifs au paiement</legend>

        <RessourceInfoBulle code="RE-RP-1" />

        <div class="mt-6 mb-4">
          <v-autocomplete
            v-model="statutEmploi.modeDeReglement"
            :item-text="itemText"
            :item-value="itemValue"
            :items="getModesDeReglement"
            :rules="rules.modeReglement"
            class="cssRequired"
            label="Mode de règlement"
            @change="modeDeReglementChange"
            required
            return-object
          />

          <v-autocomplete
            v-model="statutEmploi.nombreDePaiements"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listeNombresDePaiementsFilter"
            :rules="rules.nombrePaiement"
            class="cssRequired"
            label="Nombre de paiements"
            required
            @change="recalculerMontantFacture"
            return-object
          />
        </div>

        <RessourceInfoBulle code="RE-RP-2" />

        <div class="d-flex justify-center mb-5">
          <h2 class="grey--text text--darken-4">Aperçu de votre facture</h2>
        </div>

        <v-data-table
          :headers="headers"
          :items="this.recapValueFormat"
          :items-per-page="itemsPerPage"
          hide-default-footer
          class="elevation-1"
          width="50%"
        />

        <div>
          <v-checkbox
            v-model="termePaiement"
            color="primary"
            hide-details
            class="cssRequired"
            :rules="rules.montantFactureEngagement"
            required
          >
            <template v-slot:label>
              <div class="ml-5">
                J'ai vérifié le montant de ma facture et je m'engage à payer la totalité avant le
                <span class="font-weight-bold"><span class="text-decoration-underline">31 mars</span></span> ou en
                <span class="font-weight-bold"
                  >4 versements <span class="text-decoration-underline">(avant le 31 mars, 25 avril, 25 mai et 25 juin)</span> avec frais de
                  financement
                </span>
                afin de maintenir mon inscription au Tableau de l'Ordre.
              </div>
            </template>
          </v-checkbox>
        </div>

        <div class="text-center mt-6 d-flex justify-space-between">
          <v-btn color="primary" @click="back()">Retour</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save()">Suivant</v-btn>
        </div>
      </fieldset>
    </v-form>
  </div>
</template>
<script>
import Loader from "../Loader"
import { mapActions, mapGetters } from "vuex"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import CatalogueLoader from "@/mixins/catalogueLoader"

// IT 10328
export default {
  mixins: [NavigationPageFormulaireMixin, CatalogueLoader],
  components: {
    Loader: Loader,
  },
  data() {
    return {
      termePaiement: false,
      overlay: false,
      messageSelector: "",
      redirectValue: "",
      valid: true,
      recapValueFormat: [],
      itemsPerPage: 10,
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "libelle",
          width: "30%",
        },
        { text: "Montant avant taxes", value: "montantHt", width: "15%" },
        { text: "TPS", value: "montantTps" },
        { text: "TVQ", value: "montantTvq" },
        { text: "Total", value: "montantTtc" },
      ],
      rules: {
        montantFactureEngagement: [(v) => !!v || "Vous devez accepter ces termes"],
        modeReglement: [(v) => (!!v && v.length != 0) || "Le mode de paiement est requis"],
        nombrePaiement: [(v) => (!!v && v.length != 0) || "Le nombre de paiement est requis"],
      },
    }
  },
  async created() {
    this.messageSelector = "Loading"
    this.overlay = true

    // Chargement catalogues suivants : Mode de règlement, Nombre de paiements
    await this.loadCatalogues([2928, 2929])

    if (this.demandeInscriptionId) {
      await this.getStatutEmploiByDemandeInscriptionId(this.demandeInscriptionId)
    }

    await this.recalculerMontantFacture()
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      statutEmploi: "StatutEmploi/getStatutEmploi",
      recapitulatifPaiement: "DemandeInscription/GET_RECAPITULATIF",
      getModesDeReglement: "Catalogue/getModesDeReglement",
      getNombreDePaiements: "Catalogue/getNombreDePaiements",
    }),
    total() {
      return {
        libelle: "Total",
        montantHt: this.recapitulatifPaiement.totalHt,
        montantTps: this.recapitulatifPaiement.totalTps,
        montantTvq: this.recapitulatifPaiement.totalTvq,
        montantTtc: this.recapitulatifPaiement.totalTtc,
      }
    },
    listeNombresDePaiementsFilter() {
      return this.getNombreDePaiements.filter(
        (n) => this.statutEmploi.modeDeReglement != null && n.parent == this.statutEmploi.modeDeReglement.id
      )
    },
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getStatutEmploiByDemandeInscriptionId: "StatutEmploi/getStatutEmploiByDemandeInscriptionId",
      updateStatutEmploi: "StatutEmploi/updateStatutEmploi",
      getRecapitulatif: "DemandeInscription/getRecapPaiement",
    }),
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    save() {
      this.messageSelector = "Save"
      this.overlay = true
      this.valid = this.$refs.form.validate()

      if (this.valid) {
        try {
          this.overlay = false
          this.next()
        } catch (err) {
          console.log(err)
        }
      }
      this.overlay = false
    },
    modeDeReglementChange() {
      this.statutEmploi.nombreDePaiements = null
      this.recalculerMontantFacture()
      this.$refs.form.resetValidation()
    },
    async recalculerMontantFacture() {
      this.overlay = true
      await this.updateStatutEmploi(this.statutEmploi)
      await this.getRecapitulatif()
      this.recapitulatifPaiement.produitRecapFactureDTOs.push(this.total)

      this.recapValueFormat = this.recapitulatifPaiement.produitRecapFactureDTOs.map((recap) => {
        return {
          libelle: recap.libelle.replace(/\<br\/\>/g, ""),
          montantHt: this.$options.filters.money(recap.montantHt),
          montantTps: this.$options.filters.money(recap.montantTps),
          montantTvq: this.$options.filters.money(recap.montantTvq),
          montantTtc: this.$options.filters.money(recap.montantTtc),
        }
      })
      this.termePaiement = false
      this.overlay = false
    },
  },
}
</script>